import { CharacteristicsObject } from '../../characteristics/characteristics.model';
import { MessageObject } from '../../message/message-object.model';
import { Task } from 'src/app/services/api/tasks/tasks.service';

export class TasksOperationObject {


    constructor(public comments: MessageObject, public tasks: Array<Task>) {

    }

    public static create(): TasksOperationObject {
        return new TasksOperationObject(MessageObject.create(), new Array<Task>());
    }
}
